import React from "react";
import JoditEditor from "jodit-react";

const Editor = ({ value, buttons, activeButtonsInReadOnly, disabledPlugins, editorRef, onChange }) => {
    const config = {
        readonly: false,
        useIframeResizer: false,
        language: "pt_br",
        iframe: false,
        toolbarButtonSize: "large",
        height: 800,
        autofocus: true,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        uploader: {
            insertImageAsBase64URI: false
        },
        disabledPlugins: [...(disabledPlugins || []), "font", "fontsize", "brush"],
        activeButtonsInReadOnly: activeButtonsInReadOnly,
        buttons: buttons,
        enableDragAndDropFileToEditor: false,
        showCharsCounter: false,
        showWordsCounter: false,
        showXPathInStatusbar: false,
        placeholder: "",
        controls: {
            ul: {
                list: false // Remove dropdown de opções
            },
            ol: {
                list: false // Remove dropdown de opções
            }
        },

        // Configurações para remover formatação ao colar - versão mais robusta
        defaultActionOnPaste: "insert_clear_html", // Força texto plano sempre
        processPasteHTML: false,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,

        safeHTML: {
            allowTags: {
                p: true,
                br: true,
                strong: true,
                b: true,
                em: true,
                i: true,
                u: true,
                s: true,
                strike: true,
                ul: true,
                ol: true,
                li: true,
                div: true,
                span: true
            },
            allowAttributes: {
                style: ["text-align", "font-weight", "font-style", "text-decoration"],
                class: true
            }
        },

        // Configurações para evitar spans automáticos
        cleanHTML: {
            removeEmptyElements: true,
            replaceNBSP: true,
            fillEmptyParagraph: false,
            removeOnlyInlineElements: true
        },

        // Remove formatação inline desnecessária
        defaultMode: 1,
        enter: "P",
        useSplitMode: false,

        // Desabilitar formatação automática
        addNewLine: false,
        addNewLineOnDBLClick: false
    };

    return <JoditEditor ref={editorRef} value={value} config={config} tabIndex={1} onChange={onChange} />;
};

export default Editor;
